import React from 'react';
import {
	BrowserRouter as Router,
	Redirect,
	Route,
	Switch
} from 'react-router-dom';
import { ScreenConfigController } from '../screen-config/controller/screen-config.controller';
import { EyeTestController } from '../eye-test/controller/eye-test.controller';
import { ResultController } from '../result/controller/result.controller';
import { TextTestController } from '../eye-test/controller/text-test.controller';
import { TestExplanationController } from '../eye-test/controller/test-explanation.controller';
import { RootController } from '../eye-test/controller/root.controller';

export class AppRouter extends React.PureComponent {
	render() {
		return (
			// Note: Probably don't want www.videbis.com/videbis - but need to ask them
			<Router basename={'/Sehtest'}>
				<Switch>
					<Route path={'/setup'} component={ScreenConfigController}/>
					<Route path={'/test-explanation'} component={TestExplanationController}/>
					<Route path={'/text-test'} component={TextTestController}/>
					<Route path={'/test'} component={EyeTestController}/>
					<Route path={'/result'} component={ResultController}/>
					<Route exact path={'/'} component={RootController}/>
					<Route render={() => <Redirect to={'/'}/>}/>
				</Switch>
			</Router>
		);
	}
}
